(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  const mevInstagramRoots = new WeakSet();
  const alignMevInstagramLinks = (root) => {
    const destination = root.dataset.mevInstagramUrl;
    if (!destination) return;
    root.querySelectorAll('a.gfa-content__button').forEach((link) => {
      const current = new URL(link.href, document.baseURI);
      if (current.hostname === 'www.instagram.com' && current.pathname === '/minegenverden.dk/') {
        link.href = destination;
      }
    });
  };
  const setupMevInstagramLinks = () => {
    document.querySelectorAll('[data-mev-instagram-url]').forEach((root) => {
      if (mevInstagramRoots.has(root)) return;
      mevInstagramRoots.add(root);
      alignMevInstagramLinks(root);
      const observer = new MutationObserver(() => alignMevInstagramLinks(root));
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) observer.disconnect();
      });
    });
  };
  setupMevInstagramLinks();
  document.addEventListener('shopify:section:load', setupMevInstagramLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-highlights"] && !Shopify.designMode) return;
  try {
    
  class ImagesHighlights extends HTMLElement {
    constructor() {
      super();

      // Cache DOM
      this.highlightItemsArr = Array.from(this.querySelectorAll('[data-highlight-item]'));
      this.contentItemsArr = Array.from(this.querySelectorAll('[data-highlight-item-content]'));
      this.mobileItemsArr = Array.from(this.querySelectorAll('[data-highlight-item-content-mobile]'));
      this.buttonsArr = Array.from(this.querySelectorAll('button[id^="yv-item-"]'));
      this.navButtons = Array.from(this.querySelectorAll('[data-action="previous"], [data-action="next"]'));
      this.isMobile = window.matchMedia('(max-width: 767px)').matches;

      // State
      this.animationCount = 0;
      this.animationQueue = [];
      this.currentMobileIndex = 0;
      this.resizeHandler = null;
    }

    connectedCallback() {
      this.init();
      this.setupResizeListener();
    }

    disconnectedCallback() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }

    waitForLayout(cb) {
      requestAnimationFrame(() => {
        requestAnimationFrame(cb);
      });
    }

    setupResizeListener() {
      this.resizeHandler = () => {
        const maxW = this.getDynamicMaxWidth();

        // Update desktop max-widths
        this.contentItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${maxW}px`;
        });

        // Update mobile max-widths
        this.mobileItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = '100%';
        });

        // ---- MODE SWITCH DETECTOR ----
        const nowMobile = window.matchMedia('(max-width: 767px)').matches;

        if (nowMobile !== this.isMobile) {
          this.isMobile = nowMobile;

          if (this.isMobile) {
            // ENTERING MOBILE MODE
            this.resetMobileState();
          } else {
            // ENTERING DESKTOP MODE
            this.resetDesktopState();
          }
        }
      };

      window.addEventListener('resize', this.resizeHandler);
    }

    resetMobileState() {
      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!wrapper) return;

      wrapper.style.transform = 'translateX(0)';
      this.currentMobileIndex = 0;

      // this.measureWhenVisible(wrapper, () => {
      //   this.initMobileFirstItem();
      // });
      this.measureWhenVisible(wrapper, () => {
        this.waitForLayout(() => {
          this.initMobileFirstItem();
        });
      });

    }

    resetDesktopState() {
      // Clear any mobile inline junk
      this.mobileItemsArr.forEach(item => {
        item.classList.remove('active');
        item.style.width = '';
        item.style.height = '';
      });

      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (wrapper) {
        wrapper.style.transform = '';
      }
    }

    measureWhenVisible(el, cb) {
      if (!el) return;

      const check = () => {
        if (el.offsetParent !== null) {
          cb();
        } else {
          requestAnimationFrame(check);
        }
      };

      check();
    }

    /* ---------------- CORE UTILS ---------------- */
    startAnimation() {
      this.animationCount++;
    }

    endAnimation() {
      this.animationCount = Math.max(0, this.animationCount - 1);

      if (this.animationCount === 0 && this.animationQueue.length) {
        const next = this.animationQueue.shift();
        requestAnimationFrame(() => {
          if (next.type === 'activate') this.activateItem(next.buttonId);
          if (next.type === 'navigate') this.navigate(next.direction);
        });
      }
    }

    isAnimating() {
      return this.animationCount > 0;
    }

    queueOrRun(action) {
      if (this.isAnimating()) {
        this.animationQueue.push(action);
        return true;
      }
      return false;
    }

    /* ---------------- LAYOUT ---------------- */
    getDynamicMaxWidth() {
      const wrapper = this.querySelector('.yv-images-highlights-content-wrapper');

      if (!wrapper) {
        const available = window.innerWidth - 120;
        return Math.min(470, available);
      }

      const style = getComputedStyle(wrapper);
      const padding = (parseFloat(style.paddingLeft) || 0) +
                      (parseFloat(style.paddingRight) || 0);

      const available = window.innerWidth - padding - 20;
      return Math.min(470, Math.max(280, available));
    }

    setupResizeListener() {
      this.resizeHandler = () => {
        const maxW = this.getDynamicMaxWidth();

        this.contentItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${maxW}px`;
        });

        this.mobileItemsArr.forEach(item => {
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = '100%';
        });
      };

      window.addEventListener('resize', this.resizeHandler);
    }

    /* ---------------- IMAGE ANIMATION ---------------- */

    animateImageActive(el) {
      this.startAnimation();

      const duration = 600;
      const start = performance.now();

      const from = { scale: 0.8333, x: 200, o: 0 };
      const to = { scale: 1, x: 0, o: 1 };

      el.style.visibility = 'visible';
      el.style.display = 'grid';
      el.style.transform = `matrix(${from.scale},0,0,${from.scale},${from.x},0)`;
      el.style.opacity = from.o;

      const ease = t => 1 - Math.pow(1 - t, 3);

      const frame = now => {
        const p = Math.min((now - start) / duration, 1);
        const e = ease(p);

        const scale = from.scale + (to.scale - from.scale) * e;
        const x = from.x + (to.x - from.x) * e;
        const o = from.o + (to.o - from.o) * e;

        el.style.transform = `matrix(${scale},0,0,${scale},${x},0)`;
        el.style.opacity = o;
        el.style.pointerEvents = p === 1 ? 'auto' : 'none';

        p < 1 ? requestAnimationFrame(frame) : this.endAnimation();
      };

      requestAnimationFrame(frame);
    }

    animateImageInactive(el) {
      this.startAnimation();

      const duration = 500;
      const start = performance.now();

      const from = { scale: 1, x: 0, o: 1 };
      const to = { scale: 0.8333, x: -200, o: 0 };

      const ease = t => t * t * t;

      const frame = now => {
        const p = Math.min((now - start) / duration, 1);
        const e = ease(p);

        const scale = from.scale + (to.scale - from.scale) * e;
        const x = from.x + (to.x - from.x) * e;
        const o = from.o + (to.o - from.o) * e;

        el.style.transform = `matrix(${scale},0,0,${scale},${x},0)`;
        el.style.opacity = o;
        el.style.pointerEvents = 'none';

        if (p < 1) {
          requestAnimationFrame(frame);
        } else {
          el.style.transform = '';
          el.style.opacity = '0';
          el.style.visibility = 'hidden';
          this.endAnimation();
        }
      };

      requestAnimationFrame(frame);
    }

    /* ---------------- CONTENT ANIMATION ---------------- */

    animateItem(item) {
      
      this.startAnimation();

      const body = item.querySelector('[data-highlight-body]');
      if (!body) {
        this.endAnimation();
        return;
      }

      const parent = body.parentElement;

      // SAVE INLINE STYLES (not computed, inline only — like your original)
      const originalStyles = {
        position: parent.style.position || '',
        opacity: parent.style.opacity || '',
        visibility: parent.style.visibility || '',
      };

      // FORCE VISIBLE FOR MEASURE
      parent.style.position = 'static';
      parent.style.opacity = '1';
      parent.style.visibility = 'visible';
      body.style.opacity = '1';
      body.style.visibility = 'visible';

      // MEASURE
      const bodyHeight = body.scrollHeight;

      const button = item.querySelector('button');
      const buttonHeight = button ? button.offsetHeight : 48;
      const buttonWidth = button ? button.offsetWidth : 0;

      const finalWidth = Math.max(
        this.getDynamicMaxWidth(),
        buttonWidth
      );

      // FULL RESTORE — NO SHORTCUTS
      parent.style.position = originalStyles.position;
      parent.style.opacity = originalStyles.opacity;
      parent.style.visibility = originalStyles.visibility;
      body.style.opacity = '';
      body.style.visibility = '';

      // RESET ACTIVE STATE LIKE YOUR ORIGINAL
      const wasActive = item.classList.contains('active');
      if (wasActive) item.classList.remove('active');

      item.style.width = `${buttonWidth}px`;
      item.style.height = `${buttonHeight}px`;

      if (wasActive) item.classList.add('active');

      const widthDiff = finalWidth - buttonWidth;
      const heightDiff = bodyHeight - buttonHeight;

      const duration = 600;
      const start = performance.now();

      const easeOut = t => 1 - Math.pow(1 - t, 3);

      const frame = now => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = easeOut(progress);

        const currentW = buttonWidth + widthDiff * eased;
        const currentH = buttonHeight + heightDiff * eased;

        item.style.width = `${currentW}px`;
        item.style.height = `${currentH}px`;

        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          this.endAnimation();
        }
      };

      requestAnimationFrame(frame);
    }

 
    /* ---------------- ACTIVATION ---------------- */

    activateItemFINE(buttonId) {
      if (!buttonId) return;
      if (this.queueOrRun({ type: 'activate', buttonId })) return;

      this.highlightItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItem === buttonId;
        const wasActive = item.classList.contains('active');

        if (isActive && !wasActive) {
          item.classList.add('active');
          this.animateImageActive(item);
        }

        if (!isActive && wasActive) {
          item.classList.remove('active');
          this.animateImageInactive(item);
        }
      });

      this.contentItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItemContent === buttonId;

        if (isActive) {
          item.classList.add('active');
          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${this.getDynamicMaxWidth()}px`;
          this.animateItem(item);
        }  else {
          this.startAnimation();

          const currentWidth = item.offsetWidth;
          const currentHeight = item.offsetHeight;

          const button = item.querySelector('button');
          const buttonHeight = button ? button.offsetHeight : 48;
          const buttonWidth = button ? button.offsetWidth : 0;

          const widthDiff = buttonWidth - currentWidth;
          const heightDiff = buttonHeight - currentHeight;

          const duration = 400;
          const start = performance.now();

          const easeInOut = t =>
            t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

          const frame = now => {
            const p = Math.min((now - start) / duration, 1);
            const e = easeInOut(p);

            item.style.width = `${currentWidth + widthDiff * e}px`;
            item.style.height = `${currentHeight + heightDiff * e}px`;

            if (p < 1) {
              requestAnimationFrame(frame);
            } else {
              item.classList.remove('active');
              item.style.width = '';
              item.style.height = '';
              this.endAnimation();
            }
          };

          requestAnimationFrame(frame);
        }

      });
    }

    activateItem(buttonId) {
      if (!buttonId) return;
      if (this.queueOrRun({ type: 'activate', buttonId })) return;

      this.highlightItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItem === buttonId;
        const wasActive = item.classList.contains('active');

        if (isActive && !wasActive) {
          item.classList.add('active');
          this.animateImageActive(item);
        }

        if (!isActive && wasActive) {
          item.classList.remove('active');
          this.animateImageInactive(item);
        }
      });

      this.contentItemsArr.forEach(item => {
        const isActive = item.dataset.highlightItemContent === buttonId;

        if (isActive) {
          item.classList.add('active');

          const body = item.querySelector('.yv-images-highlights-body-inner');
          if (body) body.style.maxWidth = `${this.getDynamicMaxWidth()}px`;

          // force reflow
          item.offsetHeight;

          // start fade-in
          item.classList.add('animating');

          this.animateItem(item);
        } else {
          // start fade-out
          item.classList.remove('animating');

          this.startAnimation();

          const currentWidth = item.offsetWidth;
          const currentHeight = item.offsetHeight;

          const button = item.querySelector('button');
          const buttonHeight = button ? button.offsetHeight : 48;
          const buttonWidth = button ? button.offsetWidth : 0;

          const widthDiff = buttonWidth - currentWidth;
          const heightDiff = buttonHeight - currentHeight;

          const duration = 400;
          const start = performance.now();

          const easeInOut = t =>
            t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

          const frame = now => {
            const p = Math.min((now - start) / duration, 1);
            const e = easeInOut(p);

            item.style.width = `${currentWidth + widthDiff * e}px`;
            item.style.height = `${currentHeight + heightDiff * e}px`;

            if (p < 1) {
              requestAnimationFrame(frame);
            } else {
              item.classList.remove('active');
              item.style.width = '';
              item.style.height = '';
              this.endAnimation();
            }
          };

          requestAnimationFrame(frame);
        }
      });
    }


    /* ---------------- NAV ---------------- */

    navigate(direction) {
      if (this.queueOrRun({ type: 'navigate', direction })) return;

      const index = this.buttonsArr.findIndex(btn =>
        this.highlightItemsArr.some(item =>
          item.dataset.highlightItem === btn.id &&
          item.classList.contains('active')
        )
      );

      const nextIndex =
        direction === 'next'
          ? (index + 1) % this.buttonsArr.length
          : (index - 1 + this.buttonsArr.length) % this.buttonsArr.length;

      const target = this.buttonsArr[nextIndex];
      if (target) this.activateItem(target.id);
    }

    /* ---------------- MOBILE ---------------- */

    mobileNavigateOLD(action) {
      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!wrapper || !this.mobileItemsArr.length) return;

      const width = wrapper.offsetWidth || window.innerWidth;
      const total = this.mobileItemsArr.length;

      const next =
        action === 'next'
          ? (this.currentMobileIndex + 1) % total
          : (this.currentMobileIndex - 1 + total) % total;

      const current = this.mobileItemsArr[this.currentMobileIndex];
      const target = this.mobileItemsArr[next];

      if (current) {
        current.classList.remove('active');
        current.style.height = '';
      }

      if (target) {
        target.classList.add('active');

        const body = target.querySelector('[data-highlight-body]');
        const button = target.querySelector('button');

        if (body && button) {
          const h = body.scrollHeight + button.offsetHeight;
          target.style.height = `${h}px`;
        }
      }

      wrapper.style.transform = `translateX(${-next * width}px)`;
      this.currentMobileIndex = next;
    }

    mobileNavigate(action) {
      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!wrapper || !this.mobileItemsArr.length) return;

      const total = this.mobileItemsArr.length;

      const next =
        action === 'next'
          ? (this.currentMobileIndex + 1) % total
          : (this.currentMobileIndex - 1 + total) % total;

      const current = this.mobileItemsArr[this.currentMobileIndex];
      const target = this.mobileItemsArr[next];

      if (current) {
        current.classList.remove('active');
        current.style.height = '';
      }

      if (target) {
        target.classList.add('active');

        const body = target.querySelector('[data-highlight-body]');
        const button = target.querySelector('button');

        if (body && button) {
          const h = body.scrollHeight + button.offsetHeight;
          target.style.height = `${h}px`;
        }
      }

      // REAL SLIDE MATH
      const targetLeft = target.offsetLeft;
      wrapper.style.transform = `translateX(${-targetLeft}px)`;

      this.currentMobileIndex = next;
    }


    initMobileFirstItem() {
      const mobileWrapper = this.querySelector('.yv-images-highlights-content-mobile');
      if (!mobileWrapper || !this.mobileItemsArr.length) return;

      this.currentMobileIndex = 0;
      mobileWrapper.style.transform = 'translateX(0)';

      const wrapperWidth = mobileWrapper.offsetWidth || window.innerWidth;

      this.mobileItemsArr.forEach((item, index) => {
        const bodyInner = item.querySelector('.yv-images-highlights-body-inner');
        if (bodyInner) bodyInner.style.maxWidth = '100%';

        if (index !== 0) {
          item.classList.remove('active');
          item.style.width = '';
          item.style.height = '';
        }
      });

      const firstItem = this.mobileItemsArr[0];
      if (!firstItem) return;

      firstItem.classList.add('active');

      const body = firstItem.querySelector('[data-highlight-body]');
      const button = firstItem.querySelector('button');
      if (!body || !button) return;

      // FORCE VISIBLE FOR MEASURE (same ritual as original)
      const parent = body.parentElement;

      const original = {
        position: parent.style.position || '',
        opacity: parent.style.opacity || '',
        visibility: parent.style.visibility || ''
      };

      parent.style.position = 'static';
      parent.style.opacity = '1';
      parent.style.visibility = 'visible';
      body.style.opacity = '1';
      body.style.visibility = 'visible';

      const bodyHeight = body.scrollHeight;
      const totalHeight = bodyHeight + button.offsetHeight;

      // RESTORE
      parent.style.position = original.position;
      parent.style.opacity = original.opacity;
      parent.style.visibility = original.visibility;
      body.style.opacity = '';
      body.style.visibility = '';

      // APPLY DIMENSIONS (this was missing)
      firstItem.style.height = `${totalHeight}px`;
      firstItem.style.width = `${wrapperWidth}px`;
    }

    /* ---------------- INIT ---------------- */

    init() {
      const firstActive = this.highlightItemsArr.find(i =>
        i.classList.contains('active')
      );

      if (firstActive) {
        const id = firstActive.dataset.highlightItem;
        const content = this.contentItemsArr.find(
          i => i.dataset.highlightItemContent === id
        );

        if (content) {
          content.classList.remove('active');
          content.style.width = '';
          content.style.height = '';

          requestAnimationFrame(() => {
            const button = content.querySelector('button');
            if (!button) return;

            content.style.width = `${button.offsetWidth}px`;
            content.style.height = `${button.offsetHeight}px`;

            requestAnimationFrame(() => {
              const body = content.querySelector('.yv-images-highlights-body-inner');
              if (body) body.style.maxWidth = `${this.getDynamicMaxWidth()}px`;
              content.classList.add('active');
              this.animateItem(content);
            });
          });
        }
      }

      this.buttonsArr.forEach(btn =>
        btn.addEventListener('click', () => this.activateItem(btn.id))
      );

      this.navButtons.forEach(btn =>
        btn.addEventListener('click', e => {
          e.preventDefault();
          const action = btn.dataset.action;
          this.navigate(action);
          this.mobileNavigate(action);
        })
      );

      const wrapper = this.querySelector('.yv-images-highlights-content-mobile');
      // this.measureWhenVisible(wrapper, () => {
      //   this.initMobileFirstItem();
      // });

      this.measureWhenVisible(wrapper, () => {
        this.waitForLayout(() => {
          this.initMobileFirstItem();
        });
      });


    }
  }

  customElements.define('images-highlights', ImagesHighlights);


  } catch(e) { console.error(e); }
})();
})();
